import React, {Fragment} from "react";
import CompanyBasicDataForm from "./CompanyBasicDataForm";
import withFormErrorHandler from "../withFormErrorHandler";
import PersonBasicDataForm from "./Person/PersonBasicDataForm";
import PersonAddressFormForCredit from "../../CreditReservation/BasicData/Person/PersonAddressFormForCredit";

function StepForBasicData(props) {

    const companyChangeHandler = company => props.onChange({...props.proposal, company: company});
    const personChangeHandler = person => props.onChange({
        ...props.proposal,
        representatives: [person]
    });

    const onNextClickHandler = () => {
        props.onCheckErrorHandler(() => (props.onNextClick()));
    }

    let formFields = props.isCompany ? (
        <CompanyBasicDataForm
            formValidator={props.formValidator}
            company={props.proposal.company}
            onChange={companyChangeHandler}/>
    ) : (
        <Fragment>
            <PersonBasicDataForm
                formValidator={props.formValidator}
                person={props.proposal.representatives[0]}
                onChange={personChangeHandler}/>
            <PersonAddressFormForCredit
                formValidator={props.formValidator}
                person={props.proposal.representatives[0]}
                onChange={personChangeHandler}/>
        </Fragment>
    );

    return (
        <Fragment>
            <div className="config-card-header">
                <div className="config-card-header-inner">
                    <p className="config-card-title">Dane podstawowe</p>
                </div>
            </div>
            <div className="config-card-body">
                <form className="order-form">
                    <div className="cr-form-grid">
                        {formFields}
                    </div>
                </form>
                <div className="config-modal-footer">
                    <div className="flex">
                        <button type="button" className="back" onClick={props.onBackClick}><i className="fa fa-angle-left"></i> Wstecz</button>
                        <button type="button" onClick={onNextClickHandler}>Dalej <i className="fa fa-angle-right"></i></button>
                    </div>
                </div>
            </div>
        </Fragment>
    );
}

export default withFormErrorHandler(StepForBasicData);